import React from "react";

export default function Dashboard() {
  return <div>Hello Dashboard!</div>;
}
